import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { logoutUser, selectUser, updateJwtToken } from '../ReduxStore/userReducer';
import { resetItemGroup, resetItems } from '../ReduxStore/actions';
import { showAlert } from '../ReduxStore/alertSlice';
import { RefreshToken, SapDisconnection } from '../API/API';
import axios from 'axios';
// import { logoutUser, resetItemGroup, resetItems } from '../ReduxStore/actions'; // Import your logout and reset actions

// const AutoLogout = ({ children }) => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const userData = useSelector(selectUser);
//     const databaseName = userData?.DatabaseName;
//     const jwtToken = userData?.JwtToken;
//     const resetToken = userData?.RefreshToken;
//     const logout = useCallback(async () => { 
//         const disconnectAPI = `${SapDisconnection}${databaseName}`;
//         await fetch(disconnectAPI, null,{
//             method: 'POST',
//             headers: {
//                 'wg_token': jwtToken,
//             },
//         });       
//         dispatch(logoutUser());
//         dispatch(resetItemGroup());
//         dispatch(resetItems());
//         dispatch(showAlert()); // This sets alertShown to true
//         localStorage.setItem('sessionExpired', 'true'); // Store session expired in localStorage
//         localStorage.removeItem('loginTime');
//         navigate('/'); // Navigate to login page without sessionExpired in location.state
//     }, [databaseName, jwtToken, dispatch, navigate]);

//     const encodedToken = encodeURIComponent(resetToken)

   
//     const resetJwt = useCallback(async () => {
//         // Call your ResetJwt API here
//         const response = await axios.post(`${RefreshToken}${encodedToken}`, {
//             headers: {
//                 'wg_token': jwtToken, // Pass the JWT token in the header
//             },
//         });
//         const newToken = response.data.token;
//         dispatch(updateJwtToken(newToken));
//         // Handle response if needed
//     }, [jwtToken]);
    
//     const loginTime = localStorage.getItem('loginTime');
    
//     useEffect(() => {
//         let logoutTimeout;

//         const resetTimer = () => {
//             clearTimeout(logoutTimeout);

//             // Set a new timeout for 30 minutes to log out
//             logoutTimeout = setTimeout(() => {
//                 logout();
//             }, 1 * 60 * 1000);

//         };
//         // Set event listeners for user activity
//         window.addEventListener('mousemove', resetTimer);
//         window.addEventListener('keypress', resetTimer);
//         window.addEventListener('click', resetTimer);
//         window.addEventListener('scroll', resetTimer);

//         // Initialize the timer
//         resetTimer();

//         return () => {
//             clearTimeout(logoutTimeout);
//             // Remove event listeners on cleanup
//             window.removeEventListener('mousemove', resetTimer);
//             window.removeEventListener('keypress', resetTimer);
//             window.removeEventListener('click', resetTimer);
//             window.removeEventListener('scroll', resetTimer);
//         };
//     }, [logout]);

//     useEffect(() => {
//         let resetJwtTimeout;

//         const startResetJwtTimer = () => {
//             clearTimeout(resetJwtTimeout);
//             resetJwtTimeout = setTimeout(() => {
//                 resetJwt();
//             }, 25 * 60 * 1000); // 25 minutes
//         };

//         // Start the JWT reset timer immediately
//         startResetJwtTimer();

//         return () => {
//             clearTimeout(resetJwtTimeout);
//         };
//     }, [resetJwt]);
//     // useEffect(() => {
        
//     //     if (!loginTime) {
//     //         return;
//     //     }
//     //     // Calculate the remaining time until logout
//     //     const remainingTime = 60 * 60 * 1000 - (Date.now() - loginTime);

//     //     if (remainingTime > 0) {
//     //         const timeout = setTimeout(() => {
//     //             logout();
//     //         }, remainingTime);

//     //         return () => clearTimeout(timeout);
//     //     } else {
//     //         logout();
//     //     }
//     // }, [logout,loginTime]);

//     return <>{children}</>;
// };

// const AutoLogout = ({ children }) => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const location = useLocation();
//     const userData = useSelector(selectUser);
//     const userId = userData?.UserId;
//     const jwtToken = userData?.JwtToken;
//     const resetToken = userData?.RefreshToken;
//     const isLoginPage = location.pathname === '/login'; // Check if on login page

//     // Initialize last activity time from localStorage
//     const [lastActivityTime, setLastActivityTime] = useState(() => {
//         const storedTime = localStorage.getItem(`lastActivityTime_${userId}`);
//         return storedTime ? parseInt(storedTime) : Date.now(); // Default to current time
//     });

//     const logout = useCallback(() => {
//         dispatch(logoutUser());
//         dispatch(resetItemGroup());
//         dispatch(resetItems());
//         dispatch(showAlert());
//         localStorage.setItem('sessionExpired', 'true');
//         localStorage.removeItem(`lastActivityTime_${userId}`);
//         navigate('/');  // Navigate to login page
//     }, [dispatch, navigate, userId]);

//     const resetTimer = useCallback(() => {
//         if (isLoginPage || !userData || !userId) return;

//         const currentTime = Date.now();
//         console.log("Activity detected. Resetting timer at:", currentTime);

//         // Store the new last activity time in localStorage
//         localStorage.setItem(`lastActivityTime_${userId}`, currentTime);

//         // Update the state to trigger the next render
//         setLastActivityTime(currentTime);
//     }, [isLoginPage, userData, userId]);

//     const resetJwt = useCallback(async () => {
//         // Refresh token logic here
//         const encodedToken = encodeURIComponent(resetToken);
//         const response = await axios.post(`${RefreshToken}${encodedToken}`, {
//             headers: {
//                 'wg_token': jwtToken, // Pass the JWT token in the header
//             },
//         });
//         console.log("New token:", response);
//         const newToken = response.data.token;
//         dispatch(updateJwtToken(newToken));
//     }, [jwtToken, resetToken, dispatch]);

//     useEffect(() => {
//         if (isLoginPage || !userData) return; // Skip if on login page or no user data

//         // Initialize last activity time if not set already
//         if (!lastActivityTime) {
//             const currentTime = Date.now();
//             localStorage.setItem(`lastActivityTime_${userId}`, currentTime); // Set initial time
//             setLastActivityTime(currentTime); // Update state with initial time
//         }

//         // Function to check session expiry based on inactivity
//         const checkSessionExpiry = () => {
//             const currentTime = Date.now();
//             const storedLastActivityTime = localStorage.getItem(`lastActivityTime_${userId}`);
            
//             if (!storedLastActivityTime) {
//                 console.log("No last activity time found. Skipping expiry check.");
//                 return;
//             }

//             const inactivityDuration = currentTime - storedLastActivityTime; // Duration in ms
//             const sessionExpired = inactivityDuration > 3 * 60 * 1000; // 3 minutes timeout

//             if (sessionExpired) {
//                 console.log("Session expired. Logging out...");
//                 logout();  // Log the user out if the session expired
//             }
//         };

//         // Check session expiration every 1 minute
//         const intervalId = setInterval(checkSessionExpiry, 60 * 1000); // Check every minute

//         // Cleanup: Clear interval on component unmount
//         return () => {
//             clearInterval(intervalId); 
//         };
//     }, [isLoginPage, userData, userId, lastActivityTime, logout]);

//     useEffect(() => {
//         // Add event listeners to reset inactivity timer on activity
//         window.addEventListener('mousemove', resetTimer);
//         window.addEventListener('keypress', resetTimer);
//         window.addEventListener('click', resetTimer);
//         window.addEventListener('scroll', resetTimer);

//         // Cleanup: Remove event listeners on component unmount
//         return () => {
//             window.removeEventListener('mousemove', resetTimer);
//             window.removeEventListener('keypress', resetTimer);
//             window.removeEventListener('click', resetTimer);
//             window.removeEventListener('scroll', resetTimer);
//         };
//     }, [resetTimer]);

//     useEffect(() => {
//         let resetJwtTimeout;

//         const startResetJwtTimer = () => {
//             clearTimeout(resetJwtTimeout);
//             resetJwtTimeout = setTimeout(() => {
//                 resetJwt();
//             }, 2 * 60 * 1000); // Refresh token every 2 minutes
//         };

//         // Start the JWT reset timer immediately
//         startResetJwtTimer();

//         return () => {
//             clearTimeout(resetJwtTimeout);
//         };
//     }, [resetJwt]);

//     return <>{children}</>;
// };

const AutoLogout = ({ children }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const userData = useSelector(selectUser);
    const userId = userData?.UserId;
    const jwtToken = userData?.JwtToken;
    const resetToken = userData?.RefreshToken;
    const isLoginPage = location.pathname === '/login'; // Check if on login page

    const [lastActivityTime, setLastActivityTime] = useState(() => {
        // Initialize the lastActivityTime from localStorage if available
        const storedTime = localStorage.getItem(`lastActivityTime_${userId}`);
        return storedTime ? parseInt(storedTime) : Date.now(); // Default to current time
    });

    const logout = useCallback(() => {
        dispatch(logoutUser());
        dispatch(resetItemGroup());
        dispatch(resetItems());
        dispatch(showAlert());
        localStorage.setItem('sessionExpired', 'true');
        localStorage.removeItem(`lastActivityTime_${userId}`);
        navigate('/');  // Navigate to login page
    }, [dispatch, navigate, userId]);

    const resetTimer = useCallback(() => {
        if (isLoginPage || !userData || !userId) return;

        const currentTime = Date.now();

        // Store the new last activity time in localStorage
        localStorage.setItem(`lastActivityTime_${userId}`, currentTime);

        // Update the state to trigger the next render
        setLastActivityTime(currentTime);
    }, [isLoginPage, userData, userId]);

    useEffect(() => {
        if (isLoginPage || !userData) return; // Skip if on login page or no user data

        // Initialize last activity time if not set already
        if (!lastActivityTime) {
            const currentTime = Date.now();
            localStorage.setItem(`lastActivityTime_${userId}`, currentTime); // Set initial time
            setLastActivityTime(currentTime); // Update state with initial time
        }

        // Function to check session expiry based on inactivity
        const checkSessionExpiry = () => {
            const currentTime = Date.now();
            const storedLastActivityTime = localStorage.getItem(`lastActivityTime_${userId}`);
            
            if (!storedLastActivityTime) {
                return;
            }

            const inactivityDuration = currentTime - storedLastActivityTime; // Duration in ms
            const sessionExpired = inactivityDuration > 60 * 60 * 1000; // 1 hour timeout

            if (sessionExpired) {
                logout();  // Log the user out if the session expired
            }
        };

        // Check session expiration every 1 hour
        const intervalId = setInterval(checkSessionExpiry, 60 * 60 * 1000); // Check every minute

        // Cleanup: Clear interval on component unmount
        return () => {
            clearInterval(intervalId); 
        };
    }, [isLoginPage, userData, userId, lastActivityTime, logout]);

    useEffect(() => {
        // Add event listeners to reset inactivity timer on activity
        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keypress', resetTimer);
        window.addEventListener('click', resetTimer);
        window.addEventListener('scroll', resetTimer);

        // Cleanup: Remove event listeners on component unmount
        return () => {
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keypress', resetTimer);
            window.removeEventListener('click', resetTimer);
            window.removeEventListener('scroll', resetTimer);
        };
    }, [resetTimer]);

    return <>{children}</>;
};

export default AutoLogout;

